import { useEffect, useState } from "react";
import { requester } from "../../requester";
import { Spin } from "antd";

const NumberOfUsers = () => {
  const [userCount, setUserCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await requester.get("/admin/totalUsersCount");
        setUserCount(response.data);
      } catch (err: any) {
        console.error("Error fetching user count:", err);
        setError(
          err.response?.data?.message || "Failed to fetch user count"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchUserCount();
  }, []);

  return (
    <div className="numberOfUsersPage">
      <Spin size="large" spinning={loading}>
        <div className="container element-center flex-col gap-4 pt-10 pb-16">
          <div className="flex flex-col items-center gap-4">
            <h1 className="text-2xl font-medium text-[#22222A] italic leading-normal">
              Number of Users
            </h1>
            {error ? (
              <div className="text-red-500 text-lg">{error}</div>
            ) : (
              <div className="text-4xl font-bold text-[#3F67AD]">
                {userCount !== null ? userCount : "—"}
              </div>
            )}
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default NumberOfUsers;

